import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCrown, faCalendarAlt, faClock, faCheckCircle, faExclamationTriangle, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import { usePlan } from '../../PlanContext';
import './PlanInfoCard.css';

export default function PlanInfoCard() {
    const { plan, vence, diasRestantes, activo, vencido, mensaje, isPlus, loading } = usePlan();

    if (loading) {
        return <div className='planCard'><div className='planCardLoading'>Cargando plan...</div></div>;
    }

    let estado, estadoIcon, estadoColor, estadoTexto;
    if (!activo) {
        estado = 'inactivo'; estadoIcon = faTimesCircle; estadoColor = '#dc3545';
        estadoTexto = 'Servicio suspendido';
    } else if (diasRestantes == null) {
        estado = 'sinFecha'; estadoIcon = faClock; estadoColor = '#6c757d'; estadoTexto = 'Sin fecha definida';
    } else if (vencido || diasRestantes < 0) {
        estado = 'vencido'; estadoIcon = faTimesCircle; estadoColor = '#dc3545';
        estadoTexto = `Vencido hace ${Math.abs(diasRestantes)} ${Math.abs(diasRestantes) === 1 ? 'día' : 'días'}`;
    } else if (diasRestantes <= 7) {
        estado = 'critico'; estadoIcon = faExclamationTriangle; estadoColor = '#fd7e14';
        estadoTexto = diasRestantes === 0 ? 'Vence hoy' : `Vence en ${diasRestantes} ${diasRestantes === 1 ? 'día' : 'días'}`;
    } else if (diasRestantes <= 30) {
        estado = 'porVencer'; estadoIcon = faExclamationTriangle; estadoColor = '#ffc107';
        estadoTexto = `Vence en ${diasRestantes} días`;
    } else {
        estado = 'vigente'; estadoIcon = faCheckCircle; estadoColor = '#28a745';
        estadoTexto = `Vigente · ${diasRestantes} días restantes`;
    }

    const formatFecha = (iso) => {
        if (!iso) return '—';
        const [y, m, d] = iso.split('-');
        return `${d}/${m}/${y}`;
    };

    return (
        <div className={`planCard planCard${isPlus ? 'Plus' : 'Basic'}`}>
            <div className='planCardHeader'>
                <FontAwesomeIcon icon={faCrown} className='planCardCrown' />
                <span className='planCardLabel'>Tu plan</span>
            </div>
            <div className='planCardNombre'>{plan.toUpperCase()}</div>

            <div className='planCardDivider' />

            <div className='planCardRow'>
                <FontAwesomeIcon icon={faCalendarAlt} className='planCardIcon' />
                <div>
                    <div className='planCardRowLabel'>Vencimiento</div>
                    <div className='planCardRowValue'>{formatFecha(vence)}</div>
                </div>
            </div>

            <div className='planCardEstado' style={{ background: `${estadoColor}15`, color: estadoColor, borderColor: estadoColor }}>
                <FontAwesomeIcon icon={estadoIcon} />
                <span>{estadoTexto}</span>
            </div>

            {(estado === 'critico' || estado === 'vencido' || estado === 'inactivo') && (
                <div className='planCardAlerta'>
                    {mensaje || 'Renová tu suscripción para no perder acceso al sistema.'}
                </div>
            )}
        </div>
    );
}
